import React, { useState } from 'react';
import PromosForm from './PromosForm';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import {
  putAPI_Update_Promos
} from '../../../../../../../constants/APIs';
import PropTypes from 'prop-types';
import Validation from '../../../../../../../components/Validation';
export default function UpdatePromosForm({ id, propertyId }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleSubmit = data => {
    const formmatedData = { ...data, updater: 'admin' };
    delete formmatedData.id;
    delete formmatedData.images;
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Promos}/${id}`,
      data: formmatedData,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    });
  };

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      {isUpdating && (
        <PromosForm
          formLabel="Update the Promotion"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          propertyId={propertyId}
        />
      )}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}

UpdatePromosForm.propTypes = {
  id: PropTypes.string.isRequired,
};
